import client from './client';

export async function listWorkflowCategories() {
  const { data } = await client.get('/workflow-categories');
  return data.data;
}

export async function listStepDefinitions() {
  const { data } = await client.get('/step-definitions');
  return data.data;
}

export async function addWorkflowStep(categoryId, payload) {
  const { data } = await client.post(`/workflow-categories/${categoryId}/workflow-steps`, payload);
  return data.data;
}

export async function updateWorkflowStep(id, payload) {
  const { data } = await client.put(`/workflow-steps/${id}`, payload);
  return data.data;
}

export async function deleteWorkflowStep(id) {
  await client.delete(`/workflow-steps/${id}`);
}

export async function copyWorkflowStep(id, targetCategoryIds) {
  const { data } = await client.post(`/workflow-steps/${id}/copy`, { target_category_ids: targetCategoryIds });
  return data;
}

export async function reorderWorkflowSteps(categoryId, steps) {
  const { data } = await client.patch(`/workflow-categories/${categoryId}/workflow-steps/reorder`, { steps });
  return data.data;
}

export async function createStepGroup(categoryId, name) {
  const { data } = await client.post(`/workflow-categories/${categoryId}/step-groups`, { name });
  return data.data;
}

export async function updateStepGroup(id, name) {
  const { data } = await client.put(`/step-groups/${id}`, { name });
  return data.data;
}

export async function deleteStepGroup(id) {
  await client.delete(`/step-groups/${id}`);
}

export async function listDocumentTypes() {
  const { data } = await client.get('/document-types');
  return data.data;
}

export async function createDocumentType(payload) {
  const { data } = await client.post('/document-types', payload);
  return data.data;
}

export async function updateDocumentType(id, payload) {
  const { data } = await client.put(`/document-types/${id}`, payload);
  return data.data;
}

export async function toggleDocumentType(id) {
  const { data } = await client.patch(`/document-types/${id}/toggle-active`);
  return data.data;
}
